import { render, staticRenderFns } from "./MInplayMulti.vue?vue&type=template&id=52e85c3e&scoped=true"
import script from "./MInplayMulti.vue?vue&type=script&lang=js"
export * from "./MInplayMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e85c3e",
  null
  
)

export default component.exports